import Dialog from '@stimulus-components/dialog'

// 急な欠員のご相談モーダル。募集一覧・ダッシュボードのカード、フッターの複数トリガーから
// 開かれる共有ダイアログ。開閉・送信のGTMイベント送出と、送信ボタンの二重送信防止を担当する。
export default class extends Dialog {
  static targets = ['submit', 'entryPointField', 'urgencyInput', 'wrap']

  get dialogTarget() {
    return this.element
  }

  // dialog-open-triggerが開いた直後に発火する。entry_pointをhidden fieldへ反映してから記録する
  trackOpen(event) {
    if (this.hasEntryPointFieldTarget) this.entryPointFieldTarget.value = event.detail.entryPoint

    this.#pushEvent('sudden_absence_modal_open', { entry_point: event.detail.entryPoint })
  }

  // Escキー押下時（<dialog>のcancelイベント）
  cancelClose(event) {
    event.preventDefault()
    this.closeWithTracking()
  }

  // 背景クリック時（.modal-wrapがdialog全体を埋めるため、判定対象はdialogTargetではなくwrapTarget）
  backdropClose(event) {
    if (event.target !== this.wrapTarget) return

    this.closeWithTracking()
  }

  // ×ボタン・キャンセルボタン押下時
  closeWithTracking() {
    this.#pushEvent('sudden_absence_modal_cancel', { entry_point: this.#entryPoint() })
    this.close()
  }

  // 送信ボタン押下時。二重送信防止のため無効化する。
  // 通信エラー等でページ遷移が起きなかった場合に備え、turbo:submit-endで再有効化する。
  handleSubmit(event) {
    this.#pushEvent('sudden_absence_modal_submit', { entry_point: this.#entryPoint(), urgency: this.#urgency() })

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      event.target.addEventListener('turbo:submit-end', () => {
        this.submitTarget.disabled = false
      }, { once: true })
    }
  }

  #entryPoint() {
    return this.hasEntryPointFieldTarget ? this.entryPointFieldTarget.value : undefined
  }

  #urgency() {
    return this.urgencyInputTargets.find((input) => input.checked)?.value
  }

  #pushEvent(eventName, params = {}) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: eventName, ...params })
  }
}
